import React from 'react';
import { getAppPath } from './utils/runtimeMode';

const Unauthorized = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '20%' }}>
            <h1>403 - Unauthorized</h1>
            <p>You are not authorized to view this page.</p>
            <a href={getAppPath('/')} style={{ color: 'blue', textDecoration: 'underline' }}>
                Go back to Home
            </a>
        </div>
    );
};

export default Unauthorized;